import { fontText, lineHeightToFontSize } from 'common-react';
import {
  createStyles,
  makeStyles,
  Theme,
  ThemeColorsModel,
  ThemeFontSizeModel,
} from 'ui-components';

export default makeStyles((theme: Theme & {
  color: ThemeColorsModel;
  fontFamily: {
    ingMeWebBold: string;
  };
  fontSize: ThemeFontSizeModel;
}) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 0,
  },

  card: {
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: 16,
    },
  },

  resultCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },

  resultHeader: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 16,
  },

  resultValue: {
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },

  rateAccent: {
    fontFamily: theme.fontFamily.ingMeWebBold,
    fontWeight: 700,
    color: theme.color.maroons[100],
  },

  chartCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },

  chart: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    minWidth: 0,
  },

  chartLegend: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px 24px',
    margin: 0,
    padding: '0 0 0 8px',
    listStyle: 'none',
  },

  chartLegendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },

  chartLegendMarker: {
    width: 32,
    height: 24,
    borderRadius: 50,
    flexShrink: 0,
  },

  notice: {
    margin: 0,
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.color.blues[10],
    color: theme.color.greys[80],
    font: fontText('normal', theme.fontSize.s, lineHeightToFontSize.s),
  },

  noticeAccent: {
    fontFamily: theme.fontFamily.ingMeWebBold,
    fontWeight: 700,
  },
}), { name: 'RetirementCalculatorResult' });
